import {Button} from "antd";
import styled from "styled-components";

export const StyledBackButton = styled(Button)`
    background-color: black;
    outline: none;
    border: none;

    &:hover,
    &:focus,
    &:active,
    &:visited {
        background-color: black;
        outline: none;
        border: none;
    }
`;
